import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, useUitkContext } from 'uitk-react-utils';
import styles from './uitk-text.css';
import { UitkParagraphSizes } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkParagraph = function (props) {
    var size = props.size, children = props.children, className = props.className, attributes = __rest(props, ["size", "children", "className"]);
    var _a = useUitkContext(), contextData = _a.data, context = _a.context;
    var _b = contextData !== null && contextData !== void 0 ? contextData : {}, bottomScrimContext = _b.bottomScrimContext, overlayScrimContext = _b.overlayScrimContext, contextClassNames = _b.contextClassNames;
    var baseClassName = 'uitk-paragraph';
    var wrapperClassNames = getClassNameList(baseClassName, !bottomScrimContext && size && UitkParagraphSizes.get(size), bottomScrimContext && "in-bottom-scrim", overlayScrimContext && "in-overlay-scrim", context === 'uitk-dialog-context' && 'in-dialog', contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.UitkParagraph, className);
    return children ? (React.createElement("p", __assign({ className: wrapperClassNames }, attributes), children)) : null;
};
UitkParagraph.displayName = 'UitkParagraph';
UitkParagraph.defaultProps = {
    size: 2
};

export { UitkParagraph };
